import React, { ButtonHTMLAttributes, ReactNode } from 'react'

import { Container } from './styles'

interface ButtonRootProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode
  backgroundColor: string
  padding?: string
  border?: string
  hoverColor?: string
  type?: 'button' | 'submit' | 'reset'
}

export const ButtonRoot = ({
  children,
  backgroundColor,
  padding,
  border,
  hoverColor,
  type = 'button',
  ...props
}: ButtonRootProps) => {
  return (
    <Container
      backgroundcolor={backgroundColor}
      padding={padding}
      border={border}
      type={type}
      hovercolor={hoverColor}
      {...props}
    >
      {children}
    </Container>
  )
}
